const styles = {
  container: {
    color: '#666',
    // backgroundColor: '#F4F5F0',

  },
  summary: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  summary_left: {
    display: 'flex',

  },
  groupstage: {
    // backgroundColor: '#fff',
    padding: '8px',
  },
  statsrow: {
    backgroundColor: '#F4F5F0',
    padding: '10px 8px',
    borderBottom: '1px solid lightgray',
  },

  statstitle: {
    fontSize: '20px',
    borderBottom: '1px solid lightgray',
    padding: '15px 8px',
    // cursor: 'pointer',
  },
  statstitlem: {
    fontSize: '14px',
    borderBottom: '1px solid lightgray',
    padding: '15px 8px',
    background: '#fff',
    // cursor: 'pointer',
  },
  kpi: {
    padding: '2em',
  },
  kpim: {
    padding: '1em',
  },
  kpititle: {
    fontSize: 16,
    textAlign: 'center',
    color: '#787878',
  },
  kpinum: {
    color: '#444',
    fontSize: 62,
    maxHeight: 52,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  kpinumm: {
    color: '#444',
    fontSize: 42,
    maxHeight: 52,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  intro: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '10px 10px 30px',
  },
  introm: {
    textAlign: 'center',
  },
  // NAVIGATION BAR
  navbar: {
    background: 'url(assets/images/background-header.png)',
    backgroundColor: '#7F1431',
    padding: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    backrgoundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    marginBottom: '10px',
  },
  nav_text: {
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    textTransform: 'uppercase',
  },
  nav_title: {
    fontSize: '30px',
    // marginRight: '10px',
    fontFamily: 'League Gothic',
    color: '#FFFFFF',
  },
  nav_anchor: {
    paddingLeft: '20px',
    '& a': {
      cursor: 'pointer',
      textDecoration: 'none',
      color: '#aaa',
    },
    '& :hover': {
      color: '#fff',
    },
  },
  nav_anchorselected: {
    marginLeft: '20px',
    // borderBottom: '3px solid #fff',
  },
  nav_title_mob: {
    fontSize: '18px',
    marginRight: '10px',
  },
  // NAVIGATION BAR
  text: {

  },
  title: {
    fontSize: '30px',
    marginRight: '10px',
  },
  titleclick: {
    fontSize: '30px',
    marginRight: '10px',
    fontFamily: 'League Gothic',
    color: '#7F1431',
  },
  learnmore: {
    marginLeft: '20px',
  },
  desc: {
    marginBottom: '10px',
    fontFamily: 'League Gothic',
    fontSize: '14px',
    textAlign: 'center',
    maxWidth: '500px',
    textTransform: 'uppercase',

  },
  buttons: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignSelf: 'baseline',
    // gap: '10px',
  },
  button: {
    color: '#fff',
    backgroundColor: '#9D9DA5',
    border: 'none',
    padding: '10px 20px',
    // fontWeight: '700',
    marginLeft: '20px',
    // fontFamily: 'League Gothic',
    cursor: 'pointer',
  },
  buttons_m: {
    display: 'flex',
    flexWrap: 'no-wrap',
    justifyContent: 'space-around',
    marginTop: '10px',
  },
  button_m: {
    color: '#fff',
    backgroundColor: '#7F1431',
    border: 'none',
    padding: '10px 20px',
    // fontWeight: '700',
    fontFamily: 'League Gothic',
    cursor: 'pointer',
  },
  autocomplete: {
    color: '#fff',
    border: 'none',
    padding: '0',
    marginLeft: '20px',
    // fontFamily: 'League Gothic',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    // fontSize: '14px',
  },
  autocomplete_icon: {
    padding: 10,
    backgroundColor: '#680923',
    alignSelf: 'center',
    fontSize: 15,
    // display: 'none',
    height: '41.5px',
  },
  autocomplete_text: {
    padding: '5px 25px',
    backgroundColor: '#7F1431',
    // border: '1px solid #ccc',
    // borderRadius: '0 5px 5px 0',
    color: '#fff',
    fontSize: 12,
    alignSelf: 'center',
    height: '41.5px',
    transition: 'background-color 0.5s ease-in-out',
    '&:hover': {
      backgroundColor: '#b7244c',
    },
  },
  startover: {
    color: '#fff',
    border: 'none',
    padding: '5px 0',
    marginLeft: '20px',
    // fontFamily: 'League Gothic',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    // fontSize: '14px',
  },
  startover_icon: {
    padding: 10,
    backgroundColor: '#808089',
    alignSelf: 'center',
    fontSize: 12,
    height: '41.5px',
    // display: 'none',
  },
  startover_text: {
    padding: 10,
    backgroundColor: '#9D9DA5',
    color: '#fff',
    fontSize: 12,
    alignSelf: 'center',
    whiteSpace: 'nowrap',
    height: '41.5px',
    transition: 'background-color 0.5s ease-in-out',
    '&:hover': {
      backgroundColor: '#b6b6bf',
    },
  },
  smalltext: {
    textAlign: 'center',
    fontSize: 9,
  },
  bracket: {
    overflow: 'auto',
    padding: '0 8px 8px 8px',
  },

  legend: {
    display: 'flex',
    // fontFamily: 'League Gothic',
    fontSize: '12px',
    fontWeight: '600',
    margin: '0 0 10px 0',
  },
  legend_icon_first: {
    width: '14px',
    height: '14px',
    border: '1px solid #62AD1D',
    backgroundColor: '#62AD1D',
    borderRadius: '100%',
    margin: '1px 5px 0 0',

  },
  legend_icon_second: {
    width: '14px',
    height: '14px',
    border: '1px solid #F9981D',
    backgroundColor: '#F9981D',
    borderRadius: '100%',
    margin: '1px 5px 0 20px',
  },
  // dialog
  dia: {
    // background: 'url(assets/images/bg-choose-your-champion.png) center',
    // backgroundSize: 'cover',
    // backgroundColor: '#222',
    color: '#fff',
    // padding: '70px 100px 0',
    textAlign: 'center',
  },
  dia_intro: {
    // padding: '0 30%',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  dia_introrow: {
    textAlign: 'center',
    paddingTop: '10px',
  },
  dia_introrow2: {
    textAlign: 'center',
  },
  closerow: {
    textAlign: 'right',
  },
  close: {
    cursor: 'pointer',
  },
  img_close: {
    width: '20px',
  },
  scrollarea: {
    maxHeight: '445px',
    maxWidth: '100%',
    overflow: 'auto',
    marginBottom: '50px',
    border: '1px solid #dedede',
    padding: '20px',
  },
  dia_title: {
    textAlign: 'center',
    fontFamily: 'League Gothic',
    fontSize: '42px',
    // margin: '0 0 20px 0',
    color: '#7F1431',
  },
  dia_logo: {
    height: '240px',
    // marginTop: '15px',
  },
  dia_logo2: {
    height: '62px',
  },
  dia_subtitle: {
    fontFamily: 'League Gothic',
    fontSize: '28px',
    // margin: '0 0 20px 0',
    color: '#7F1431',
  },
  dia_descrip: {
    maxWidth: '630px',
    margin: '0 auto',
    fontSize: '20px',
    textAlign: 'center',
  },
  dia_desc: {
    margin: '0 auto',
    // fontFamily: 'League Gothic',
    fontSize: '14px',
    // padding: '0 40px 0 20px',
    '& img': {
      width: '60%',
    },
  },
  dia_credit: {
    textAlign: 'center',
    marginTop: '15px',
  },
  dia_legal: {
    fontSize: '13px',
    textAlign: 'center',
    marginTop: '-6px',
  },
  dia_buttons: {
    display: 'flex',
    justifyContent: 'center',
    // marginTop: '2rem',
    gap: '20px',
  },
  dia_crimg: {
    height: '60px',
  },
  dia_button: {
    // border: '1px solid #fff',
    // padding: '10px 30px',
    // margin: '20px auto',
    // maxWidth: '260px',
    // textAlign: 'center',
    // backgroundColor: 'rgba(10, 10, 10, .5)',
    // cursor: 'pointer',
    // fontSize: '28px',
    // fontFamily: 'League Gothic',
    // '&:hover': {
    //   backgroundColor: 'rgba(10, 10, 10, .8)',
    // },
    // '& a': {
    //   textDecoration: 'none',
    //   color: '#fff',
    // },
    textDecoration: 'none',
    lineHeight: '55px',
    position: 'relative',
    display: 'block',
    overflow: 'hidden',
    height: '55px',
    width: '249px',
    // margin: '0.4rem 0.6rem 0 0.6rem',
    textTransform: 'uppercase',
    border: '1px solid #7F1431',
    borderRadius: 0,
    textAlign: 'center',
    cursor: 'pointer',
    fontSize: '24px',
    fontFamily: 'League Gothic',
    backgroundColor: '#7F1431',
    color: '#FFFFFF',
    // transition: '0.5s ease-in',
    boxSizing: 'border-box',
    // boxShadow: 'inset 0 0 0 0 #D80286',
    backfaceVisibility: 'hidden',
    '& > span': {
      position: 'relative',
      zIndex: 2,
    },
    '& > a': {
      position: 'relative',
      zIndex: 2,
      textDecoration: 'none',
      color: '#FFFFFF',
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: '-50px',
      bottom: 0,
      left: 0,
      // borderTop: '40px solid #FFFFFF',
      borderBottom: '55px solid #FFFFFF',
      borderRight: '50px solid transparent',
      transform: 'translateX(-100%)',
      transition: 'transform 0.5s ease-in',
      zIndex: 0,
    },
    // '&:after': {
    //   content: '""',
    //   position: 'absolute',
    //   top: 0,
    //   right: 0,
    //   bottom: 0,
    //   left: ' -50px',
    //   // borderTop: '40px solid #FFFFFF',
    //   borderBottom: '80px solid #FFFFFF',
    //   // borderLeft: '40px solid transparent',
    //   transform: 'translateX(100%)',
    //   transition: 'transform 0.3s ease-in-out',
    //   zIndex: 1,
    // },
    '&:hover': {
      color: '#7F1431',
      // backgroundColor: '#FFFFFF',
      // width: '250px',
      '& > a': {
        color: '#7F1431',
      },
      '&:before': {
        transform: 'translateX(0%)',
      },
      // '&:after': {
      //   transform: 'translateX(40%)',
      // },
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '60px',
    fontSize: '22px',

  },
  howitworks: {
    // marginRight: '20px',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontFamily: 'League Gothic',
    fontSize: '24px',
    marginTop: '25px',
    textAlign: 'center',
    display: 'inline-block',
  },
  pickforme: {
    marginLeft: '20px',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  hiw_dialog: {
    backgroundColor: '#fff',
    color: '#333',
  },
  hiw_content: {
    padding: '20px',
  },
  hiw_dia_button: {
    border: '1px solid #333',
    padding: '10px 60px',
    margin: '40px auto 0',
    maxWidth: '186px',
    textAlign: 'center',
    // backgroundColor: 'rgba(10, 10, 10, .5)',
    cursor: 'pointer',
    fontSize: '28px',
  },
  cols: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    fontFamily: 'League Gothic',
    marginBottom: '20px',
    // gridColumnGap: '10px',
  },
  col: {
    textAlign: 'center',
  },
  col_img: {
    maxHeight: '150px',
    maxWidth: '220px',
  },
  coltext: {
    textAlign: 'left',
    padding: '0 10px',
  },
  col_text_middle: {
    textAlign: 'left',
    padding: '0 10px',
    borderLeft: '1px solid lightgray',
    borderRight: '1px solid lightgray',

  },
  // mobile intro
  diam: {
    background: 'url(assets/background_intro.jpg) bottom',
    backgroundSize: 'cover',
    backgroundColor: '#222',
    color: '#fff',
    height: '820px',
  },
  descm: {
    // margin: '0 10px',
    // fontFamily: 'League Gothic',
    fontSize: '12px',
    textAlign: 'left',
    // textTransform: 'uppercase',
    padding: '10px 20px',
    backgroundColor: '#fff',
  },
  dia_logom: {
    height: '200px',
    marginTop: '10px',
  },
  dia_descripm: {
    fontFamily: 'League Gothic',
    fontSize: '14px',
    textAlign: 'center',
    padding: '0 10px',
  },
  dia_buttonm: {
    border: '1px solid #fff',
    padding: '10px',
    margin: '20px auto',
    maxWidth: '260px',
    textAlign: 'center',
    backgroundColor: 'rgba(10, 10, 10, .5)',
    fontSize: '28px',
    fontFamily: 'League Gothic',
    '& a': {
      textDecoration: 'none',
      color: '#fff',
    },
  },
  dia_creditm: {
    textAlign: 'center',
  },
  dia_legalm: {
    fontSize: '9px',
    textAlign: 'center',
    // margin: '20px 0',
  },
  roundname: {
    // width: 'calc(100% - 16px)',
    padding: '10px',
    fontSize: '30px',
    textAlign: 'center',
    background: '#fff',
    fontFamily: 'League Gothic',
    borderBottom: '1px solid lightgray',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  next: {
    textDecoration: 'none',
    padding: '8px 20px',
    background: '#7F1431',
    color: '#fff',
    fontSize: '16px',
    boxShadow: '0 1px 3px rgba(0,0,0,.175)',

  },
  // mobile intro
  // hamburger menu
  hamburger: {
    cursor: 'pointer',
    alignSelf: 'center',
    width: '20px',
  },
  hamb: {
    height: 2,
    backgroundColor: '#fff',
    marginBottom: 4,
  },
  qliklogo: {
    alignSelf: 'center',
    width: '200px',
    textAlign: 'right',
  },
  qlik: {
    height: 50,
  },
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    // padding: '20px',
    // backgroundColor: '#FFFFFF',
    background: 'url(assets/images/bg-choose-your-champion.png) bottom',
    backgroundSize: 'cover',
    backgroundColor: '#222',
    // height: '90%',
    height: 'auto',
    overflowY: 'auto',
    maxHeight: '686px',
  },
  footerBracket: {
    position: 'fixed',
    left: '0',
    bottom: '0',
    width: '100%',
    backgroundColor: '#f3f3f3',
  },
  footerBracketContent: {
    display: 'flex',
    padding: '10px 0',
    color: '#000',
    justifyContent: 'center',
    fontSize: '14px',
    flexDirection: 'column',
    alignItems: 'center',
    '& > a': {
      color: '#606060',
      textDecoration: 'none',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'none',
        color: '#9f465e',
      },
    },
  },
  linksFooter: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: '18px',
    marginBottom: '5px',
    '& > span': {
      marginRight: '5px',
      fontFamily: 'League Gothic',
      textTransform: 'uppercase',
    },
    '& > a': {
      color: '#606060',
      textDecoration: 'none',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'none',
        color: '#9f465e',
      },
    },
  },
  linkWithIcon: {
    margin: '0 5px',
    '& > a': {
      color: '#606060',
      textDecoration: 'none',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'none',
        color: '#9f465e',
      },
      '&#fb': {
        color: '#4267B2',
      },
      '&#tw': {
        color: '#1DA1F2',
      },
      '&#li': {
        color: '#0072b1 ',
      },
      svg: {
        fontSize: '16px',
      },
    },
  },

  '@media (max-width: 601px)': {
    modalContainer: {
      height: '90%',
      overflowY: 'auto',
      maxHeight: '629px',
    },
    dia: {
      padding: '10px',
    },
    dia_logo: {
      height: '187px',
    },
    dia_logo2: {
      width: '100%',
    },
    dia_descrip: {
      fontSize: '13px',
    },
    dia_buttons: {
      flexDirection: 'column',
    },
    dia_credit: {
      // marginTop: '70px',
    },
    dia_crimg: {
      height: '52px',
    },
    dia_legal: {
      fontSize: '9px',
      marginTop: '-6px',
    },
    dia_button: {
      textDecoration: 'none',
      lineHeight: '50px',
      position: 'relative',
      display: 'block',
      overflow: 'hidden',
      height: '50px',
      textTransform: 'uppercase',
      border: '1px solid #7F1431',
      borderRadius: 0,
      textAlign: 'center',
      cursor: 'pointer',
      fontSize: '20px',
      fontFamily: 'League Gothic',
      backgroundColor: '#7F1431',
      color: '#FFFFFF',
      boxSizing: 'border-box',
      backfaceVisibility: 'hidden',
      margin: '0 auto',
      width: '210px',
      '& > span': {
        position: 'relative',
        zIndex: 2,
      },
      '& > a': {
        position: 'relative',
        zIndex: 2,
        textDecoration: 'none',
        color: '#FFFFFF',
      },
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        right: '-50px',
        bottom: 0,
        left: 0,
        borderBottom: '50px solid #FFFFFF',
        borderRight: '50px solid transparent',
        transform: 'translateX(-100%)',
        transition: 'transform 0.5s ease-in',
        zIndex: 0,
      },

      '&:hover': {
        color: '#7F1431',
        '& > a': {
          color: '#7F1431',
        },
        '&:before': {
          transform: 'translateX(0%)',
        },
      },
    },
  },

};

export default styles;
